<div class="header" mat-dialog-title>
  <h3>{{ 'coupons.nav.segmentsGrid' | translate }}</h3>
</div>

<div class="messages">
  <txp-message [type]="messageType.DANGER" data-qa-label="LoadingErrorMsg" *ngIf="loadingError">
    {{ 'coupons.grid.loadingErrorMsg' | translate }}
  </txp-message>
  <txp-message [type]="messageType.DANGER" data-qa-label="EnableErrorMsg" *ngIf="enableError">
    {{ 'coupons.grid.enableErrorMsg' | translate }}
  </txp-message>
  <txp-message [type]="messageType.WARNING" data-qa-label="EmptySearchList" *ngIf="emptySearchList">
    {{ 'coupons.grid.emptySearchListMsg' | translate }}
  </txp-message>
</div>

<div class="header">
  <div class="header-actions">
    <div class="search-filter-container">
      <mat-form-field class="search-input">
        <i matPrefix class="tce-icon-search"></i>
        <input matInput (keyup)="filter($event.target.value)" [placeholder]="'coupons.segments.grid.search' | translate"/>
      </mat-form-field>
    </div>
    <txp-button
      [hidden]="segmentsReadOnly"
      data-qa-label="CreateSegmentButton"
      [style]="buttonStyle.PRIMARY"
      [size]="buttonSize.SMALL"
      (click)="createSegment()"
    >
      {{ 'coupons.segments.grid.createSegmentBtn' | translate }}
    </txp-button>
  </div>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<div class="table-content" [hidden]="isLoading">
  <table
    mat-table
    [dataSource]="dataSource"
    #matTable
    matSort
    (matSortChange)="setSorting($event)"
    matSortActive="createdDate"
    matSortDirection="desc"
    matSortDisableClear
    [hidden]="isLoading"
    class="segments-list"
  >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          data-qa-label="MasterToggleCheckBox"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          data-qa-label="MenuRowCheckBox"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="segmentName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.segments.grid.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let segment">
        <a
          class="edit-link"
          (click)="editSegment(segment)"
          [attr.title]="'form.button.edit' | translate"
          data-qa-label="EditLink"
          href="javascript:void(0);"
        >
          {{ segment.segmentName }}
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'coupons.segments.grid.count' | translate }}
      </th>
      <td mat-cell *matCellDef="let segment">
        {{ segment.userCount }}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'coupons.segments.grid.createdBy' | translate }}
      </th>
      <td mat-cell *matCellDef="let segment">
        {{ segment.createdBy }}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdDate">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'coupons.segments.grid.createdDate' | translate }}
      </th>
      <td mat-cell *matCellDef="let segment">
        {{ segment.createdDate | date: 'MM/dd/yyyy hh:mm:ss a' }}
      </td>
    </ng-container>

    <!-- footer for "still loading" message -->
    <ng-container matColumnDef="loading">
      <td mat-footer-cell *matFooterCellDef colspan="100">
        <div>
          <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
          {{ 'segment.grid.loading' | translate }}
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    <tr
      mat-footer-row
      *matFooterRowDef="['loading']; sticky: true"
      [hidden]="!isLoading || page === 0"
    ></tr>
  </table>
  <div class="show-more">
    <txp-button
      (click)="loadMoreSegments()"
      [disabled]="isLoading || isLastPage"
      [loading]="loadingMore"
      [size]="buttonSize.SMALL"
      [style]="buttonStyle.NOBACKGROUND"
    >{{ 'coupons.grid.showMore' | translate }}</txp-button
    >
  </div>
</div>
